import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import { sameHeight } from './sameHeight';

// Use mainObj. instead of document. (because of Shadow DOM)
const mainObj = document.querySelector('#tmo_rtt');

/**
 * DOMContentLoaded
 */
document.addEventListener('DOMContentLoaded', function () {
    sameHeight();

    /**
     * FAQ
     */
    const FAQ = mainObj.querySelectorAll('.faq__item');
    const FAQactiveClass = 'faq__item--active';
    const FAQcontent = '.faq__item-content';
    const FAQhead = '.faq__item-head';

    const openAccordion = (accordion) => {
        const content = accordion.querySelector(FAQcontent);
        accordion.classList.add(FAQactiveClass);
        content.style.maxHeight = content.scrollHeight + 25 + 'px';
    };

    const closeAccordion = (accordion) => {
        const content = accordion.querySelector(FAQcontent);
        accordion.classList.remove(FAQactiveClass);
        content.style.maxHeight = null;
    };

    FAQ.forEach((accordion) => {
        const intro = accordion.querySelector(FAQhead);
        const content = accordion.querySelector(FAQcontent);

        intro.onclick = () => {
            if (content.style.maxHeight) {
                closeAccordion(accordion);
            } else {
                FAQ.forEach((accordion) => closeAccordion(accordion)); // Remove this line to show multiple opened FAQ items at the same time
                openAccordion(accordion);
            }
        };
    });

    /**
     * Guide
     */
    mainObj.querySelectorAll('.guide .swiper').forEach((el) => {
        const swiper = new Swiper(el, {
            modules: [Navigation, Pagination],
            loop: false,
            slidesPerView: 1,
            speed: 0,
            spaceBetween: 40,
            autoHeight: true,
            navigation: {
                nextEl: el.querySelector('.swiper-button-next'),
                prevEl: el.querySelector('.swiper-button-prev'),
            },
            pagination: {
                el: el.querySelector('.swiper-pagination'),
                clickable: true,
            },
            breakpoints: {
                501: {
                    spaceBetween: 0,
                    autoHeight: false,
                },
            },
        });

        const mainPrev = el.querySelector('.swiper-button-prev');
        const mainNext = el.querySelector('.swiper-button-next');

        const allPrevBtns = el.querySelectorAll('.swiper-button-prev');
        const allNextBtns = el.querySelectorAll('.swiper-button-next');

        allPrevBtns.forEach((btn) => {
            btn.classList.add('swiper-button-disabled');
        });

        allPrevBtns.forEach((btn) => {
            if (btn !== mainPrev) {
                btn.addEventListener('click', () => swiper.slidePrev());
            }
        });

        allNextBtns.forEach((btn) => {
            if (btn !== mainNext) {
                btn.addEventListener('click', () => swiper.slideNext());
            }
        });

        const updateNavVisibility = () => {
            const isBeginning = swiper.isBeginning;
            const isEnd = swiper.isEnd;

            allPrevBtns.forEach((btn) => {
                btn.classList.toggle('swiper-button-disabled', isBeginning);
            });

            allNextBtns.forEach((btn) => {
                btn.classList.toggle('swiper-button-disabled', isEnd);
            });
        };

        swiper.on('init slideChange reachBeginning reachEnd', updateNavVisibility);

        swiper.init();
    });

    /**
     * Modals
     */
    const openBtns = mainObj.querySelectorAll('.open-modal-btn');

    let lastFocusedButton = null;

    openBtns.forEach((btn) => {
        btn.addEventListener('click', (e) => {
            lastFocusedButton = e.currentTarget;
            const targetSelector = btn.dataset.target;
            const modal = mainObj.querySelector(targetSelector);
            if (!modal) return;

            modal.classList.add('show');
            modal.setAttribute('aria-hidden', 'false');

            const modalContent = modal.querySelector('.modal__content');
            modalContent.focus();

            // Close modal handlers
            const closeBtn = modal.querySelector('.modal__close');
            const closeLink = modal.querySelector('.modal__close-link');
            const overlay = modal.querySelector('.modal__overlay');

            // Define close function here for this modal instance
            const closeModal = () => {
                modal.classList.remove('show');
                modal.setAttribute('aria-hidden', 'true');
                if (lastFocusedButton) lastFocusedButton.focus();

                // Clean up event listeners to avoid duplicates
                closeBtn.removeEventListener('click', closeModal);
                overlay.removeEventListener('click', closeModal);
                mainObj.removeEventListener('keydown', onEsc);
            };

            // Close on close button
            closeBtn.addEventListener('click', closeModal);
            if (closeLink) {
                closeLink.addEventListener('click', closeModal);
            }

            // Close on overlay click
            overlay.addEventListener('click', closeModal);

            // Close on Escape key
            const onEsc = (event) => {
                if (event.key === 'Escape') {
                    closeModal();
                }
            };
            mainObj.addEventListener('keydown', onEsc);
        });
    });
});
